export interface Category {
  id: string;
  name: string;
  alias: string;
  tagline: string;
  icon: string;
  accent: string;
}

export interface Post {
  id: string;
  cat: string;
  title: string;
  kicker: string;
  summary: string;
  date: string;
  reads: string;
  comments: number;
  tags: string[];
  img: string;
  featured?: boolean;
  pillar?: boolean;
}

export const site = {
  name: "每日大瓜",
  slogan: "理性吃瓜 · 求锤得锤",
  desc: "娱乐吃瓜情报与行业舆情观察的编辑部站点",
};

export const categories: Category[] = [
  {
    id: "prove",
    name: "瓜友求锤得锤",
    alias: "求锤区",
    tagline: "旧账新料一次对明白，吃瓜群众齐上阵",
    icon: "ri-question-answer-line",
    accent: "text-primary-600",
  },
  {
    id: "prophet",
    name: "预言家挖坟现场",
    alias: "挖坟区",
    tagline: "把早年间说过的每一句翻出来复盘",
    icon: "ri-timer-flash-line",
    accent: "text-accent-600",
  },
  {
    id: "back",
    name: "粉丝脱粉回踩",
    alias: "回踩区",
    tagline: "曾经有多爱，清醒之后话就有多密",
    icon: "ri-user-unfollow-line",
    accent: "text-secondary-600",
  },
  {
    id: "cam",
    name: "站姐爆料专区",
    alias: "站姐区",
    tagline: "镜头背后的一手现场与行程侧记",
    icon: "ri-camera-3-line",
    accent: "text-primary-600",
  },
  {
    id: "insider",
    name: "业内匿名爆料",
    alias: "业内区",
    tagline: "片场综艺录制幕后的匿名信源",
    icon: "ri-user-voice-line",
    accent: "text-accent-600",
  },
];

export const posts: Post[] = [
  {
    id: "p01",
    cat: "insider",
    title: "一线综艺录制现场的隐形规则：艺人下班后为什么还要多待四十分钟",
    kicker: "业内独家",
    summary:
      "一位曾在头部户外综艺跟组多年的场务匿名复盘：嘉宾离场顺序、机位补录与后期剪接之间，藏着一条看不见的“人情时间线”。",
    date: "09-09",
    reads: "128.6w",
    comments: 3412,
    tags: ["综艺幕后", "业内信源"],
    img: "https://readdy.ai/api/search-image?query=editorial%20behind%20the%20scenes%20television%20studio%20corridor%20with%20harsh%20stage%20lighting%20and%20camera%20rigs%2C%20warm%20cream%20and%20deep%20coral%20red%20color%20grading%2C%20film%20grain%2C%20moody%20cinematic%20documentary%20style%2C%20empty%20set%20at%20night&width=1400&height=900&seq=gua-insider-hero&orientation=landscape",
    featured: true,
  },
  {
    id: "p02",
    cat: "cam",
    title: "机场贵宾通道口的三分钟：站姐镜头里没有滤镜的疲惫与强撑",
    kicker: "站姐手记",
    summary:
      "跟机五年，我拍过凌晨两点抵达的顶流，也拍过同一天连赶三座城的小糊咖。镜头背后，所谓神图不过是疲惫里的一场体面。",
    date: "09-09",
    reads: "96.3w",
    comments: 2187,
    tags: ["站姐现场", "追星记录"],
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20empty%20airport%20tarmac%20at%20dawn%20with%20soft%20long%20shadows%2C%20long%20exposure%20light%20streaks%2C%20cream%20and%20sage%20green%20and%20coral%20color%20palette%2C%20documentary%20film%20grain%2C%20quiet%20melancholic%20atmosphere&width=1200&height=800&seq=gua-cam-01&orientation=landscape",
    pillar: true,
  },
  {
    id: "p03",
    cat: "prophet",
    title: "三年前那条“断更预告”被挖出来了：原来结局早写在他自己的小作文里",
    kicker: "挖坟复盘",
    summary:
      "预言家们不是有超能力，只是比大多数人更早读懂了字里行间的伏笔。回看三年，一条动态早已道尽后来的所有走向。",
    date: "09-08",
    reads: "80.1w",
    comments: 1654,
    tags: ["预言复盘", "名场面"],
    img: "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20old%20newspaper%20clippings%20and%20polaroid%20photos%20scattered%20on%20cream%20desk%2C%20magnifying%20glass%2C%20warm%20amber%20light%2C%20vintage%20archive%20aesthetic%2C%20sage%20green%20and%20coral%20accents%2C%20film%20grain&width=1200&height=800&seq=gua-prophet-01&orientation=landscape",
    pillar: true,
  },
  {
    id: "p04",
    cat: "prove",
    title: "被反复截图的一年：那场跨年晚会的走位到底有没有错位",
    kicker: "逐帧对证",
    summary:
      "有人截出一帧说“明显拉开距离”，也有人翻出全场机位。我们把同一分钟的四路镜头逐帧对齐，答案也许并不复杂。",
    date: "09-08",
    reads: "66.9w",
    comments: 1230,
    tags: ["逐帧分析", "求锤现场"],
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20multiple%20monitors%20showing%20timecode%20and%20video%20timeline%20frames%20in%20a%20dim%20edit%20suite%2C%20cream%20coral%20and%20deep%20ink%20tones%2C%20documentary%20analytical%20mood%2C%20film%20grain&width=1200&height=800&seq=gua-prove-01&orientation=landscape",
  },
  {
    id: "p05",
    cat: "back",
    title: "七年老粉的自白：决定脱粉那晚，我其实松了一口气",
    kicker: "回踩长文",
    summary:
      "我不是塌房才离开，是被一次次的失望磨完了热情。回踩不是恨，是想把当年真心实意喜欢过的自己，好好收回来。",
    date: "09-07",
    reads: "54.2w",
    comments: 3980,
    tags: ["脱粉长文", "情感复盘"],
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20an%20open%20diary%20and%20ticket%20stubs%20and%20confetti%20on%20a%20warm%20cream%20desk%2C%20soft%20window%20light%2C%20coral%20and%20amber%20tones%2C%20introspective%20melancholic%20mood%2C%20film%20grain%2C%20honest%20confessional%20aesthetic&width=1200&height=800&seq=gua-back-01&orientation=landscape",
  },
  {
    id: "p06",
    cat: "insider",
    title: "片场盒饭分级是真实存在的：从导演桌到群演餐的那点差距",
    kicker: "剧组见闻",
    summary:
      "很多人好奇剧组吃饭是不是分三六九等。一位常驻横店的副导演说，层级是有的，但大家真正在意的其实是那口热乎和准时。",
    date: "09-06",
    reads: "45.8w",
    comments: 987,
    tags: ["剧组生活", "冷知识"],
    img: "https://readdy.ai/api/search-image?query=editorial%20food%20photography%20of%20chinese%20lunchbox%20meals%20in%20lunch%20boxes%20on%20a%20wooden%20film%20set%20table%2C%20warm%20cream%20lighting%2C%20coral%20napkin%20and%20sage%20green%20accents%2C%20cozy%20documentary%20behind%20scenes%20mood%2C%20film%20grain&width=1200&height=800&seq=gua-insider-02&orientation=landscape",
  },
  {
    id: "p07",
    cat: "prophet",
    title: "那场颁奖礼上被群嘲的“陪跑发言”，两年后竟成了最强预言",
    kicker: "名场面",
    summary:
      "当年弹幕都在刷尴尬，只有少数人记住了那句“时间会给出答案”。两年后回看，每一句话都落回了现实的坐标上。",
    date: "09-05",
    reads: "39.4w",
    comments: 2764,
    tags: ["颁奖礼", "预言成真"],
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20an%20elegant%20empty%20awards%20stage%20with%20warm%20golden%20spotlights%20and%20confetti%20in%20the%20air%2C%20cream%20and%20amber%20and%20coral%20tones%2C%20dramatic%20cinematic%20light%2C%20film%20grain&width=1200&height=800&seq=gua-prophet-02&orientation=landscape",
  },
  {
    id: "p08",
    cat: "cam",
    title: "活动红毯的另一面：散场后艺人同款手势背后的团队心照不宣",
    kicker: "现场观察",
    summary:
      "同一个定点姿势，不同艺人做出来完全两种气场。站姐视角里，真正的“表现力”往往发生在官方镜头都收工之后。",
    date: "09-04",
    reads: "33.7w",
    comments: 812,
    tags: ["红毯观察", "站姐视角"],
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20an%20empty%20red%20carpet%20with%20press%20cameras%20and%20step%20and%20repeat%20backdrop%2C%20coral%20red%20carpet%20rolling%20away%2C%20warm%20cream%20lighting%2C%20sage%20green%20and%20coral%20palette%2C%20quiet%20cinematic%20mood%2C%20film%20grain&width=1200&height=800&seq=gua-cam-02&orientation=landscape",
  },
  {
    id: "p09",
    cat: "back",
    title: "为什么“回踩帖”总是爆得又快又狠：一种集体止损的心理机制",
    kicker: "观点",
    summary:
      "脱粉回踩不只是情绪宣泄，更是粉丝社群自我叙事的一次集体重建。理解它，才能理解互联网情绪为什么如此整齐划一。",
    date: "09-03",
    reads: "28.9w",
    comments: 1653,
    tags: ["心理观察", "粉丝社群"],
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20many%20silhouettes%20in%20a%20dark%20theater%20looking%20toward%20bright%20screen%20light%2C%20warm%20coral%20and%20cream%20backlight%2C%20contemplative%20collective%20mood%2C%20documentary%20film%20grain&width=1200&height=800&seq=gua-back-02&orientation=landscape",
  },
  {
    id: "p10",
    cat: "prove",
    title: "一个表情包引发的“求锤”连锁：当事人下场前我们都别急",
    kicker: "求证现场",
    summary:
      "一张模糊截图的传播速度远超真相。在当事人正式回应前，所谓铁证往往只是一张高糊动图加三千条脑补评论。",
    date: "09-02",
    reads: "22.5w",
    comments: 730,
    tags: ["求证", "辟谣观察"],
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20smartphone%20screen%20with%20blurry%20zoomed%20video%20frame%20and%20chat%20notification%20bubbles%2C%20cream%20desk%20background%2C%20coral%20and%20ink%20tones%2C%20doc%20style%2C%20analytical%20mood%2C%20film%20grain&width=1200&height=800&seq=gua-prove-02&orientation=landscape",
  },
  {
    id: "p11",
    cat: "insider",
    title: "综艺“剧本感”的真相：流程是排好的，反应却是真的",
    kicker: "业内观察",
    summary:
      "做了八年综艺编剧，我想替这个职业说句话：我们确实写流程、排游戏，但艺人们绝处逢生的那声笑和那滴泪，从来不在纸上。",
    date: "09-01",
    reads: "18.3w",
    comments: 1104,
    tags: ["综艺编剧", "幕后真相"],
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20writers%20desk%20with%20scripts%20paper%20and%20colorful%20post%20it%20notes%20and%20microphone%2C%20warm%20cream%20light%2C%20coral%20and%20amber%20accents%2C%20behind%20the%20scenes%20documentary%20mood%2C%20film%20grain&width=1200&height=800&seq=gua-insider-03&orientation=landscape",
  },
  {
    id: "p12",
    cat: "prophet",
    title: "古早访谈里的那句“我这个人经不起捧”，如今听来满是伏笔",
    kicker: "考古",
    summary:
      "当所有预言都能在当事人的旧访谈里找到出处，所谓挖坟，不过是在替当初没人听懂的那句话补上一张迟到的小票。",
    date: "08-30",
    reads: "15.6w",
    comments: 920,
    tags: ["考古访谈", "伏笔"],
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20an%20old%20vintage%20microphone%20and%20audio%20tapes%20on%20a%20warm%20cream%20table%2C%20soft%20retro%20lighting%2C%20sepia%20amber%20and%20sage%20tones%2C%20nostalgic%20archive%20mood%2C%20film%20grain&width=1200&height=800&seq=gua-prophet-03&orientation=landscape",
  },
];

export interface RankItem {
  rank: number;
  title: string;
  cat: string;
  heat: string;
  trend: "up" | "down" | "new";
}

export const ranking: RankItem[] = [
  { rank: 1, title: "一线综艺隐性规则全文复盘引热议", cat: "业内爆料", heat: "128.6w", trend: "up" },
  { rank: 2, title: "机场三分钟站姐手记转发破圈", cat: "站姐专区", heat: "96.3w", trend: "new" },
  { rank: 3, title: "三年前断更预告被逐字挖坟", cat: "预言家挖坟", heat: "80.1w", trend: "up" },
  { rank: 4, title: "跨年晚会走位逐帧对证结果出", cat: "瓜友求锤", heat: "66.9w", trend: "down" },
  { rank: 5, title: "七年老粉脱粉自白引三千评论", cat: "脱粉回踩", heat: "54.2w", trend: "up" },
  { rank: 6, title: "片场盒饭分级冷知识刷屏", cat: "业内爆料", heat: "45.8w", trend: "down" },
  { rank: 7, title: "两年前陪跑发言成最强预言", cat: "预言家挖坟", heat: "39.4w", trend: "new" },
  { rank: 8, title: "红毯收工后团队心照不宣观察", cat: "站姐专区", heat: "33.7w", trend: "up" },
  { rank: 9, title: "回踩帖爆火背后的心理机制", cat: "脱粉回踩", heat: "28.9w", trend: "up" },
  { rank: 10, title: "一张高糊截图别急着下定论", cat: "瓜友求锤", heat: "22.5w", trend: "down" },
];

export const ticker: string[] = [
  "业内信源：某头部户外综艺再录一季，嘉宾阵容或在月底官宣",
  "站姐现场：跨城航班同日三班，跟机团的步数又破纪录了",
  "瓜友求锤：流传的聊天截图已被证伪，理性吃瓜别急着站队",
  "预言家挖坟：一条两年前动态冲上热榜，评论区集体喊先知",
  "编辑部提醒：图片可P、录音可剪，让子弹再飞一会儿",
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faq: FaqItem[] = [
  {
    q: "什么是“瓜友求锤得锤”？",
    a: "这是本站最受欢迎的信源栏目之一。吃瓜群众针对网传消息，通过逐帧、行程表、现场多角度视频等可核验证据去求证，直到“实锤”或“辟谣”水落石出。求锤得锤，指的就是这种不轻信、要证据的围观态度。",
  },
  {
    q: "“预言家挖坟现场”栏目会挖什么？",
    a: "我们把艺人或团队过往的访谈、动态、旧帖翻出来，对照后来发生的事逐条复盘。很多看似神奇的“预言”，其实是当事人早年在字里行间埋下的伏笔。我们只做基于公开信息的时间线整理，不做诛心之论。",
  },
  {
    q: "站姐爆料与业内爆料的可信度如何？",
    a: "站姐提供的是镜头内外的一手现场侧记，业内则偏向片场、综艺、活动的幕后规则。两者都可能受立场影响，因此本站坚持“多路信源交叉验证”，标注匿名信源与主观推测，请读者理性参考、勿轻信单一说法。",
  },
  {
    q: "网站会发布未经证实的造谣内容吗？",
    a: "不会。每日大瓜的核心原则是“理性吃瓜、不造谣不传谣”。涉及个人名誉的内容我们坚持证据先行、当事人回应优先，并对明显失实或带有攻击性的投稿进行拦截。你看到的回踩与爆料帖，均以复盘和观点讨论为主。",
  },
  {
    q: "如何投稿或提供线索？",
    a: "欢迎通过站点底部联系邮箱发送素材与线索。编辑部会先核实信源、做交叉验证，确认具备讨论价值且不伤害无辜者后才会整理发布。匿名投稿请务必提供可回溯的时间与场景，便于我们核验。",
  },
];

export interface AboutStat {
  num: string;
  label: string;
}

export const stats: AboutStat[] = [
  { num: "12+", label: "吃瓜栏目" },
  { num: "8.9k", label: "独立信源累计" },
  { num: "3200w", label: "每月瓜友到访" },
  { num: "24h", label: "编辑部值班" },
];